import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

const baseUrl = dev;
const headers = {
  'Content-type': 'application/json',
};

const config = {
  timeout: 30000,
  method: null,
  emulateJSON: true,
  url: '',
  headers,
  data: null,
};

export default {
  getSkillSheet: (staffNum) => {
    config.url = baseUrl + '/api/skillSheet/guestGet';
    config.method = 'POST';
    config.data = { staffNum };

    return axios.request(config)
      .then((res) => {
        if (res.data) {
          return res.data; // data配列を返す
        } else {
          throw new Error(res.data.message || 'エラーが起きた');
        }
      })
      .catch((err) => {
        console.log("err:    ", err)
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.message || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push(`/guestSkillsheet/${staffNum}`);
          }
        const error = new Error(errorMessage);
          error.status = err.response.status;
          throw error;
        } else {
          errorMessage = err.message;
          throw new Error(errorMessage);
        }
      });
  },
  editSkillSheet: (userName, staffNum, careerData, careerItemsData, skillSheetData) => {
    config.url = baseUrl + '/api/skillSheet/guestEdit';
    config.method = 'POST';
    config.data = { userName, staffNum, careerData, careerItemsData, skillSheetData };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },

  deleteSkillSheet: (careerItemsTrashCan, skillSheetTrashCan) => {
    config.url = baseUrl + '/api/skillSheet/guestDelete';
    config.method = 'POST';
    config.data = { careerItemsTrashCan, skillSheetTrashCan };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },
  getCheck: (staffNum, password) => {
    config.url = baseUrl + '/api/password/check';
    config.method = 'POST';
    config.data = { staffNum, password };

    return axios.request(config)
      .then((res) => {
        console.log('API response data:', res.data);
        if (res.status === 200) {
          return res.data;
        } else {
          throw new Error(res.data.message || 'ログイン 失敗');
        }
      })
      .catch((err) => {
        console.log('err:    ', err);
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.message || 'エラーが発生しました';
          if (err.response.status === 401) {
            errorMessage = err.response.data.message || 'エラーが発生しました';
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },
};
